var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeadOnly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 134 166",
    style: {
      enableBackground: "new 0 0 134 166"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F08419;}\n\t.st1{fill:#2F788A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,101l-1.7-6.7c-0.5-2.1-2.6-3.3-4.6-2.8l0,0l3.3,14.4l0,0C113.4,105.4,114.7,103.2,114.1,101z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,116.4c-0.5-0.1-1-0.3-1.4-0.7c-1.2-1.1-1.4-2.9-0.3-4.2l6-6.9c0.8-0.9,2.1-1.3,3.3-0.8l8.5,3.3 c1.5,0.6,2.3,2.3,1.7,3.8c-0.6,1.5-2.3,2.3-3.8,1.7l-6.5-2.5l-4.6,5.3C50.3,116.2,49.3,116.6,48.3,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,109.8c-0.5-0.1-1-0.3-1.4-0.7c-1.2-1.1-1.4-2.9-0.3-4.2l6-6.9c0.8-0.9,2.1-1.3,3.3-0.8l8.5,3.3 c1.5,0.6,2.3,2.3,1.7,3.8c-0.6,1.5-2.3,2.3-3.8,1.7l-6.5-2.5l-4.6,5.3C77.1,109.6,76.1,109.9,75.1,109.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.4,116.7l1.3,5.2c0.6,2.5,3.2,4.1,5.7,3.4h0L26.8,111h0C24.3,111.6,22.8,114.1,23.4,116.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.8,74.9c0,0-1.3-0.6-4.3-1c-6.1-1-19-1.7-41,3.8C25,85.7,24.2,94.4,24.2,94.4l8.7,34.9 c3-0.1,6.3-0.4,9.8-0.8l-7.9-31.9c2.8-2,9.6-5.7,25.1-9.5c18-4.5,29.1-4.5,35-3.9l7.1,28.8c3.2-1.5,6.2-3,8.9-4.5L102.8,74.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.1,74.5c-4.7,1.2-6.3,2-6.3,2l0.5,2.5c1.2-0.4,3.9-1.3,7.3-2.3c3.7-1,8.1-2.1,12.2-2.7 c1.7-0.2,3.4-0.4,5-0.4l-0.4-1.9c0,0-1.8-0.2-6.5,0.5L60.2,67l8.7-1.9c2.6-0.6,3.7-3.6,2.2-5.8L58.1,41.7c-1.4,1.1-3,1.9-4.7,2.4 l5.1,12.6l-6.8,1.3c-3.4,0.7-5.1,4.5-3.3,7.5L54.1,74.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35,137.6c0,0,0.9,2.2,6.6,3.2c4.4,0.7,11.7,0.7,23.6-1.8c2.2-0.5,4.6-1,7.2-1.6c4.6-1.1,8.7-2.3,12.4-3.5 c18.8-6.1,26-12.5,28.1-14.8c0.5-0.5,0.7-1.2,0.5-1.9l-1.4-5.6C103,116.9,91.3,122,78.2,126c-16.9,5.1-32.9,7.2-44.5,6.5L35,137.6 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.3,19c-0.3,0.1-0.7,0.1-1,0.2l5.7,10l-1.8,3l-3.3-0.1l-5.6-9.9c-2.6,2.6-3.9,6.4-3.1,10.3 c1.2,6.3,7.3,10.4,13.6,9.2c6.3-1.2,10.4-7.3,9.2-13.6C59.6,21.9,53.6,17.7,47.3,19z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadOnly);
export default __webpack_public_path__ + "static/media/icon-head-only.769db0c3c0feacfb62c38b0e1cd532a5.svg";
export { ForwardRef as ReactComponent };